import { ApiCall } from '../ApiClient';
import { dateTransformer } from '../ApiUtil';

export interface LlmModelSettings {
    apiKey?: string | null;
    endpoint?: string | null;
    [key: string]: any;
}

export interface LlmProviderData {
    id: string;
    name: string;
    label: string;
    params: Record<string, any>;
    models: string[];
    sort: number;
    createdAt: string;
}

export interface LlmModelData {
    id: string;
    accountId: string;
    modelName: string;
    settings: LlmModelSettings;
    enabled: boolean;
    createdAt: string;
    updatedAt: string;
    provider: LlmProviderData;
}

export interface AddLlmInstancesInput {
    providerId: string;
    apiKey: string;
    organizationId?: string;
    endpoint?: string;
}

const get = <TResponse>(def: Omit<ApiCall<never, TResponse>, 'method'>): ApiCall<never, TResponse> =>
    Object.assign(def, { method: 'get' });

const post = <TResponse>(def: Omit<ApiCall<any, TResponse>, 'method'>): ApiCall<any, TResponse> =>
    Object.assign(def, { method: 'post' });

const put = <TResponse>(def: Omit<ApiCall<any, TResponse>, 'method'>): ApiCall<any, TResponse> =>
    Object.assign(def, { method: 'put' });

export const llmEndpoints = {

    selectCapability: (message: string) => get<{ code: string }>({
        path: '/llm.selectCapability',
        query: { message },
    }),

    describe: (fileUrl: string) => post<{ response: string }>({
        path: '/llm.describe',
        body: { fileUrl },
    }),

    fileToObjects: (message: string, fileUrl: string) => post<any>({
        path: '/llm.fileToObjects',
        body: { message, fileUrl },
    }),

    start: (boardId: string, subjectId: string, prompt: string, attachments: Record<string, any>) => post<{ operationId: string }>({
        path: '/llm.start',
        body: { boardId, subjectId, prompt, attachments },
    }),

    providers: {
        list: () => get<LlmProviderData[]>({
            path: '/llm.providers.list',
            transform: dateTransformer(),
        }),
    },

    instances: {

        list: () => get<LlmModelData[]>({
            path: '/llm.instances.list',
            transform: dateTransformer(),
        }),

        add: (body: AddLlmInstancesInput) => post<LlmModelData[]>({
            path: '/llm.instances.add',
            body,
            transform: dateTransformer(),
        }),

        delete: (body: { ids: string[] }) => post<{ ok: boolean }>({
            path: '/llm.instances.delete',
            body,
        }),
    }

};
